/**
 * Homepage merchandising. Edit Aurora IDs only — photos, names,
 * categories and preview prices come from the existing catalogue.
 */
export const homepageFeaturedAuroraIds = [
  "330", // Anua 8 Hyaluronic Acid Hydrating Gentle Foaming Cleanser
  "751", // The Ordinary Niacinamide 10% + Zinc 1% Serum
  "401", // COSRX Advanced Snail 92 All in One Cream
  "1062", // LANEIGE Lip Glowy Balm – Berry
  "595", // Aveda Miraculous Oil
  "958", // L’Occitane Shea (Karité) Hand Cream
  "935", // Yves Saint Laurent Libre Eau de Parfum
  "1162" // Medicube Age-r LED Booster Pro Black
] as const;

export const homepageCategoryTileAuroraIds: Record<string, string> = {
  cleansers: "330",
  treatments: "751",
  moisturisers: "401",
  masks: "1229",
  suncare: "1147",
  makeup: "592",
  hair: "595",
  "body-care": "958",
  fragrance: "935",
  sets: "1232",
  devices: "1162",
  other: "546"
};
